import React, { useContext, useEffect, useRef, useState } from 'react'
import { Content } from './style'
import { OptionsButton, LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, ButtonCreate, RefreshIcon } from '../../../components/subheader-style'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import movement from '../../../assets/stock/TableMovementHeader/refresh-active.svg'
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'
import ModalContext from '../../../contexts/ModalContext'
import { TypeMainOutlet } from '..'
import { tableFields } from '../../../components/FieldManager/table-fields'
import FieldsManager, { FieldsManagerType } from '../../../components/FieldManager'
import WithoutSelectedFields from '../../SystemErrors/WithoutSelectedFields'
import StockContext from '../../../contexts/StockContext'
import FiltersMenu from '../../../components/Stock/TableMovementHeader/FiltersMenu'
import filter from '../../../assets/stock/TableMovementHeader/filter.svg'
import FiltersHeader from '../../../components/Stock/FiltersHeader'
import TableFiltersContext from '../../../contexts/TableFiltersContext'
import SectionContext from '../../../contexts/SectionContext'
import { LoadMoreButton } from '../../../components/table-style'
import arrow from '../../../assets/stock/LoadMoreButton/arrow-down.svg'
import refresh_act from '../../../assets/refresh-active.svg'
import { CompanyTypes, FilterTypesDiv } from '../../../components/Stock/TableMovementHeader/style'

export interface StockOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  fields: FieldsManagerType
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
  refresh: boolean
}

const tabs = [
  { path:'', image: stock, name: 'Estoque' },
  { path:'movement', image: movement, name: 'Movimentação' },
]

const StockSubHeader:React.FC<{tabIndexActived:number, setRefresh: React.Dispatch<React.SetStateAction<boolean>>}> = ({tabIndexActived, setRefresh}) => {
  const navigate = useNavigate()
  const companyTypesIds = ['Pedido', 'Manual']
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { resetContext } = useContext(StockContext)
  const [isFiltersMenuOpen, setIsFiltersMenuOpen] = useState<boolean>(false)
  const filterMenuRef = useRef<HTMLDivElement>(null)
  const filterDropdownRef = useRef<HTMLDivElement>(null)
  const { movementTypeFilter, setMovementTypeFilter } = useContext(TableFiltersContext)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterMenuRef.current &&
        filterDropdownRef.current &&
        !filterMenuRef.current.contains(event.target as Node) &&
        !filterDropdownRef.current.contains(event.target as Node)
      ) {
        setIsFiltersMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleSetTypes = (id: string) => {
    if (movementTypeFilter.includes(id)) {
      if (movementTypeFilter.split(',').length === 1) {
        return
      }
      setMovementTypeFilter(
        movementTypeFilter
          .split(',')
          .filter((item) => item !== id)
          .join(',')
      )
    } else {
      setMovementTypeFilter(movementTypeFilter ? `${movementTypeFilter},${id}` : id)
    }
  }

  const openModal = () => {
    resetContext()
    setModalActive(true)
    setModalSection('addStockMenu')
  }
  
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Estoque</SectionName>
      <TabsDiv>
        {tabs.map((tab, index) => (
        <Tab
          key={index}
          $isFirst={index === 0}
          $isLast={index === tabs.length - 1}
          $isActive={index === tabIndexActived}
          onClick={() => {
            if(index !== tabIndexActived) navigate(tab.path)
          }}
        >
          <img src={tab.image} alt={`${tab.path}-icon`} />
          {tab.name}
        </Tab>
        ))}
      </TabsDiv>
    </LeftSide>
    <RightSide>
      {tabIndexActived === 1 ?
        <FilterTypesDiv>
          {companyTypesIds.map((item) => (
            <CompanyTypes
              key={item}
              className={movementTypeFilter.includes(item) ? 'actived' : ''}
              onClick={() => handleSetTypes(item)}
            >
              {item}
            </CompanyTypes>
          ))}
        </FilterTypesDiv>
      : null}
      <RefreshIcon
        onClick={() => setRefresh(prev => !prev)}
        title="Atualizar"
        src={refresh_act}
        alt="Movement icon"
      />
      <OptionsButton
        onClick={() => setIsFiltersMenuOpen(!isFiltersMenuOpen)}
        ref={filterMenuRef}
      >
        <img src={filter}alt="filter-icon" />
      </OptionsButton>
      {isFiltersMenuOpen ? <FiltersMenu ref={filterDropdownRef} /> : null}
      <ButtonCreate onClick={() => openModal()}>+ Adicionar estoque</ButtonCreate>
    </RightSide>
  </SubHeaderContainer>
  )
}

const StockContent = () => {
  const [ isdropdownOpen, setIsDropdownOpen ] = useState(false)
  const [ tabIndex, setTabIndex ] = useState<number>(0)
  const { search } = useOutletContext<TypeMainOutlet>()
  const { stockFilters, movementFilters } = useContext(TableFiltersContext)
  const { stockSection } = useContext(SectionContext)
  const fromLocalStorage = localStorage.getItem('tableFields')
  const [ quantity, setQuantity ] = useState(8)
  const [ refresh, setRefresh ] = useState(false)
  const [ fields, setFields ] = useState(() => {
    if(fromLocalStorage) {
      const tableFieldsFromLocalStorage:FieldsManagerType[] = JSON.parse(fromLocalStorage)
      return tableFieldsFromLocalStorage.filter(field => field.tableSection === (tabIndex === 1 ? 'movement' : 'stock'))[0]
    }
    return tableFields.filter(field => field.tableSection === (tabIndex === 1 ? 'movement' : 'stock'))[0]
  })

  const tableFieldsJson:FieldsManagerType[] = fromLocalStorage ? JSON.parse(fromLocalStorage) : tableFields

  useEffect(() => {
    const toLocalStorage = tableFieldsJson.map((table:FieldsManagerType) => {
      if(table.tableSection === (tabIndex === 1 ? 'movement' : 'stock')) {
        return {...table, whichFieldsToShow: fields.whichFieldsToShow}
      }
      return table
    })

    localStorage.setItem('tableFields', JSON.stringify(toLocalStorage))
  }, [fields])
  
  useEffect(() => {
    if(tabIndex === 1)
      return setFields(tableFieldsJson.filter(field => field.tableSection === 'movement')[0])
    return setFields(tableFieldsJson.filter(field => field.tableSection === 'stock')[0])
  }, [tabIndex])
  
  return (
    <>
      <StockSubHeader tabIndexActived={tabIndex} setRefresh={setRefresh} />
      {stockSection === 'stock' && stockFilters.length > 0 ? <FiltersHeader /> : null}
      {stockSection === 'movement' && movementFilters.length > 0 ? <FiltersHeader /> : null}
      <Content>
        {isdropdownOpen ? <FieldsManager dropdownOpen={setIsDropdownOpen} fields={fields} setFields={setFields}/> : null}
        {fields.whichFieldsToShow.filter(field => field.checked).length === 0 ? 
          <WithoutSelectedFields dropdown={setIsDropdownOpen} /> 
        :
          <Outlet
            context={{
              tabIndex,
              setTabIndex,
              search,
              fields,
              setIsDropdownOpen,
              quantity,
              setQuantity,
              refresh
            }}
          />
        }
      </Content>
      <LoadMoreButton onClick={() => setQuantity(quantity + 8)}>
        <img src={arrow} alt="icon" />
        Carregar mais
      </LoadMoreButton>
    </>
  )
}
export default StockContent
